// extracted by mini-css-extract-plugin
module.exports = {"contentList":"ContentList_contentList__3Y1DO","tabContainer":"ContentList_tabContainer__2uuEy"};